import {styled, Box, CheckRoundedIcon} from '../../../ui-library';
import {BoxCustomImageProps} from '../../ImageUrl/Config/ImageUrl.types';
import {FLOW} from '../../../pages/RandomSampler/Config/RandomSampler.constants';


// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ApprovedBox = styled(Box)<BoxCustomImageProps>(({ theme, flow}) => ({
    background: 'transparent',
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    right: '0px',
    left: '0px',
    borderRadius: '10px',
    border: flow === FLOW.autoClasses ? '4px solid var(--common-white-100-p, #40DE7A)' : '4px solid var(--common-white-100-p, #FFF)'
}));


export const ApprovalIconContainer = styled(Box)`
    background-color:  ${({ theme }) => theme.palette.success.dark};
    border-radius: 100%;
    border: 4px solid var(--common-white-100-p, #FFF);
    position: relative;
    top: -10px;
    left: -10px;
    width: 26px;
    height: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const WaitForApprovalIconContainer = styled(ApprovalIconContainer)`
    background-color: ${({ theme }) => theme.palette.grey[900]};
    cursor: pointer;
`;


export const ApprovalIcon = styled(CheckRoundedIcon)`
    color: #FFF;
    font-weight: 700;
    width: 16px;
    height: 16px;
    cursor: pointer;
`;
